
/**
 * Possible locations where attachments can be saved and retrieved
 */
export enum PerformAuditAttachmentLocation {
    Audit = 'audit-attachments', // 
    Questions = 'question-attachments', 
    Attempted = 'attempted-attachments', 
    SubmitFormSignature = 'submt-form-sign-attachment'
}
